import { useState, useEffect } from "react";
import { ModalHeader } from "react-bootstrap";
import { useMutation, useQuery } from "react-query";
import Select from "react-select";
import { toast } from "react-toastify";
import { Modal, ModalBody, ModalFooter, Button, Spinner } from "reactstrap";
import {
  postCouponsAPI,
  getCouponById,
  updateCoupon,
} from "../../MyApi/coupons";
import { getProducts } from "../../MyApi/product";
import { getCategories } from "../../MyApi/product/categories";
import { getStores } from "../../MyApi/stores";
import ButtonGlobal from "../../Components/UI/buttonGlobal";
import i18next from "i18next";
import LangSelectModal from "../../Components/UI/langselectmodal";
import SkeletonWrapper from "../../Components/UI/skeletonWrapper";
import { getCountries } from "../../MyApi/admin/countries/countries";
import EnhancedSearchStore from "../../Components/UI/enhancedstoresearch";
import EnhancedSearchProduct from "../../Components/UI/enhancedproductsearch";
import { IoCloseCircle, IoCloseCircleOutline } from "react-icons/io5";
import { IoMdClose } from "react-icons/io";
const AddModalCoupon = ({
  isOpen,
  onClose,
  refetch,
  mode = "create",
  couponId = null,
}) => {
  const isEdit = mode === "edit";
  const isShow = mode === "show";
  const lang = i18next.language;
  const [selectedLangCode, setSelectedLangCode] = useState(lang);

  const { data: couponData, isLoading: couponLoading } = useQuery(
    ["coupon", couponId, selectedLangCode],
    () => getCouponById(couponId, selectedLangCode),
    {
      enabled: (isEdit || isShow) && !!couponId,
    },
  );

  const { data: productsData } = useQuery("getProducts", () => getProducts());
  const { data: storesData } = useQuery("getStores", () => getStores());
  const { data: categoriesDats } = useQuery("getCategories", () =>
    getCategories(),
  );
  const products = productsData?.data?.products || [];
  const stores = storesData?.data?.Stores || [];
  const categories = categoriesDats?.data?.categories || [];

  const [formData, setFormData] = useState({
    code: "",
    discount_amount: "",
    discount_type: "",
    usage_limit: "",
    usage_limit_per_user: "",
    minimum_order_amount: "",
    start_date: "",
    end_date: "",
    is_active: 1,
    selectedStores: [],
    selectedCategories: [],
    selectedProducts: [],
  });

  const [couponScope, setCouponScope] = useState("stores"); // "products", "stores", or "categories"
  const mutation = useMutation({
    mutationKey: ["postCoupon"],
    mutationFn: (postData) => postCouponsAPI(postData),
    onSuccess: (data) => {
      toast.success(`${data.message}`);
      onClose();
      refetch();
    },
    onError: (error) => {
      toast.error(`${error.response.data.message}`);
    },
  });

  const updateMutation = useMutation({
    mutationKey: ["updateCoupon"],
    mutationFn: (postData) => updateCoupon(couponId, postData),
    onSuccess: (data) => {
      toast.success(`${data.message}`);
      onClose();
      refetch();
    },
    onError: (error) => {
      toast.error(`${error.response.data.message}`);
    },
  });

  useEffect(() => {
    if ((isEdit || isShow) && couponData?.data?.coupon) {
      const coupon = couponData.data.coupon;
      setFormData({
        name: coupon.name || "",
        code: coupon.code || "",
        discount_amount: coupon.discount_amount || 0,
        discount_type: coupon.discount_type || "",
        usage_limit: coupon.usage_limit || "",
        usage_limit_per_user: coupon.usage_limit_per_user || "",
        minimum_order_amount: coupon.minimum_order_amount || 0,
        start_date: coupon.start_date ? coupon.start_date.split(" ")[0] : "",
        end_date: coupon.end_date ? coupon.end_date.split(" ")[0] : "",
        is_active: Number(coupon.is_active),
        currency_factor:coupon.currency_factor,
        country_id:  coupon.country_id      ,
        selectedStores:
          coupon.stores?.map((store) => ({
            id: store.id,
            name: store.name,
          })) || [],
        selectedCategories:
          coupon.categories?.map((cat) => ({
            value: cat.id,
            label: cat.name,
          })) || [],
        selectedProducts:
          coupon.products?.map((prod) => ({
            id: prod.id,
            name: prod.name,
          })) || [],
      });

      // Set scope based on existing data (only one can be selected)
      if (coupon.products && coupon.products.length > 0) {
        setCouponScope("products");
      } else if (coupon.stores && coupon.stores.length > 0) {
        setCouponScope("stores");
      } else if (coupon.categories && coupon.categories.length > 0) {
        setCouponScope("categories");
      }
    } else if (mode === "create") {
      // Reset form
      setFormData({
        code: "",
        discount_amount: "",
        discount_type: "",
        usage_limit: "",
        usage_limit_per_user: "",
        minimum_order_amount: "",
        start_date: "",
        end_date: "",
        is_active: 1,
        selectedStores: [],
        selectedCategories: [],
        selectedProducts: [],
      });

      // Reset scope
      setCouponScope("");
    }
  }, [isEdit, isShow, couponData, isOpen, mode]);

  const handleChange = (e) => {
    const { name, value, type } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? (e.target.checked ? 1 : 0) : value,
    }));
  };

  const handleSelectChange = (field, selectedOptions) => {

    setFormData((prev) => ({
      ...prev,
      [field]: selectedOptions,
    }));

  
  };
 
  const setStoreId =(selectedOptions)=>{
        setFormData((prev) => ({
      ...prev,
     selectedStores: selectedOptions,
    }));
  }
  const setProductId =(selectedOptions)=>{
    setFormData((prev)=>({
      ...prev ,
      selectedProducts:selectedOptions
    }))
  }
  const handleChangeLanguage = (e) => {
    setSelectedLangCode(e.target.value);
  };

  const handleSubmit = async () => {
    const submitData = new FormData();
    submitData.append("code", formData.code);
    submitData.append("discount_amount", formData.discount_amount);
    submitData.append("discount_type", formData.discount_type);
    submitData.append("usage_limit", formData.usage_limit);
    submitData.append("usage_limit_per_user", formData.usage_limit_per_user);
    submitData.append("minimum_order_amount", formData.minimum_order_amount);
    submitData.append("start_date", formData.start_date);
    submitData.append("end_date", formData.end_date);
    submitData.append("is_active", formData.is_active);
    submitData.append("coupon_type", "regular");
    submitData.append("object_type", "general");
    submitData.append("name", formData.name);
    submitData.append("country_id",formData.country_id)
      submitData.append("currency_factor",formData.currency_factor)
    // IDs من المنتجات المختارة
    formData.selectedProducts.forEach((product) =>
      submitData.append("product_ids[]", product.id),
    );

    // IDs من المتاجر المختارة
    formData.selectedStores.forEach((store) =>
      submitData.append("store_ids[]", store.id),
    );

    // IDs من الفئات المختارة
    formData.selectedCategories.forEach((category) =>
      submitData.append("category_ids[]", category.value),
    );
    

    if (isEdit) {
      submitData.append("lang", selectedLangCode);
      submitData.append("_method", "PUT");
      updateMutation.mutate(submitData);
    } else {
      mutation.mutate(submitData);
    }
  };

  const modalTitle = isShow
    ? "عرض الكوبون"
    : isEdit
      ? "تعديل الكوبون"
      : "إضافة كوبون جديد";
  const buttonText = isEdit ? "تحديث" : "حفظ";
  const countriesQuery = useQuery("getCountries", getCountries);
  const countries = countriesQuery?.data?.data?.countries || [];
 
  const handleChangeCountryId =(selectedOption)=>{
    console.log('selectedOption', selectedOption)
    setFormData((prev)=>({ ...prev, country_id: selectedOption?.id ,currency_factor:selectedOption?.currency_factor}))
  }

  return (
    <Modal isOpen={isOpen} centered backdrop={true} size="lg" className="add">
      <ModalHeader  toggle={onClose} className="fs-5 d-flex justify-content-between align-items-center">
        {modalTitle}
          <button className="btn" onClick={onClose}>
  <IoMdClose />
  </button>
      </ModalHeader>

      <ModalBody>
        {isEdit && (
          <LangSelectModal
            handleChange={handleChangeLanguage}
            selectedLangCode={selectedLangCode}
          />
        )}
        <div className="row add">
          <div className="col-12">
            <label htmlFor="">الدول</label>
            <Select
            placeholder="اختر الدولة"
            isLoading={countriesQuery.isLoading}
              options={countries}
              getOptionLabel={(e) => e.name}
              getOptionValue={(e) => e.id}
              value={countries.find((country)=>country.id ===  +formData.country_id)}
              onChange={handleChangeCountryId}
            ></Select>
          </div>
          <div className="col-md-6 mt-2">
            <label className="form-label">اسم الكوبون</label>
            <input
              type="text"
              name="name"
              placeholder="أدخل اسم الكوبون"
              className="form-control"
              value={formData.name}
              onChange={handleChange}
              disabled={isShow}
            />
          </div>
          <div className="col-md-6">
            <label className="form-label">كود الكوبون</label>
            <SkeletonWrapper isLoading={(isEdit || isShow) && couponLoading}>
              <input
                type="text"
                name="code"
                className="form-control"
                placeholder="أدخل كود الكوبون"
                value={formData.code}
                onChange={handleChange}
                disabled={isShow}
              />
            </SkeletonWrapper>
          </div>

          <div className="col-md-6">
            <label className="form-label">
              {" "}
              عدد الكوبونات المسموح باستخدامها
            </label>
            <SkeletonWrapper isLoading={(isEdit || isShow) && couponLoading}>
              <input
                type="number"
                name="usage_limit"
                min={0}
                className="form-control"
                placeholder="أدخل عدد الكوبونات المسموح باستخدامها"
                value={formData.usage_limit}
                onChange={handleChange}
                disabled={isShow}
              />
            </SkeletonWrapper>
          </div>

          <div className="col-md-6 mt-2">
            <label className="form-label">
              {" "}
              عدد الكوبونات المسموح لكل مستخدم باستخدامها
            </label>
            <SkeletonWrapper isLoading={(isEdit || isShow) && couponLoading}>
              <input
                type="number"
                name="usage_limit_per_user"
                min={0}
                className="form-control"
                placeholder="أدخل عدد الكوبونات المسموح باستخدامها"
                value={formData.usage_limit_per_user}
                onChange={handleChange}
                disabled={isShow}
              />
            </SkeletonWrapper>
          </div>
          <div className="col-12 mt-2">
            <label className="form-label mb-3">تطبيق الكوبون على:</label>

            <div className="d-flex flex-column gap-3">
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="radio"
                  name="couponScope"
                  id="scopeProducts"
                  value="products"
                  checked={couponScope === "products"}
                  onChange={(e) => {
                    setCouponScope(e.target.value);
                    // Clear other selections
                    setFormData((prev) => ({
                      ...prev,
                      selectedStores: [],
                      selectedCategories: [],
                    }));
                  }}
                  disabled={isShow}
                />
                <label className="form-check-label" htmlFor="scopeProducts">
                  المنتجات
                </label>
              </div>

              {couponScope === "products" && (
                <SkeletonWrapper
                  isLoading={(isEdit || isShow) && couponLoading}
                >
                <EnhancedSearchProduct  isMulti={true} value={formData.selectedProducts} setProductId={setProductId} />
                  
                  {/* <Select
                    isMulti
                    options={products.map((s) => ({
                      value: s.id,
                      label: s.name,
                    }))}
                    value={formData.selectedProducts}
                    onChange={(selected) =>
                      handleSelectChange("selectedProducts", selected)
                    }
                    placeholder="اختر المنتجات"
                    isDisabled={isShow}
                  /> */}
                </SkeletonWrapper>
              )}

              <div className="form-check">
                <input
                  className="form-check-input"
                  type="radio"
                  name="couponScope"
                  id="scopeStores"
                  value="stores"
                  checked={couponScope === "stores"}
                  onChange={(e) => {
                    setCouponScope(e.target.value);
                    // Clear other selections
                    setFormData((prev) => ({
                      ...prev,
                      selectedProducts: [],
                      selectedCategories: [],
                    }));
                  }}
                  disabled={isShow}
                />
                <label className="form-check-label" htmlFor="scopeStores">
                  المتاجر
                </label>
              </div>

              {couponScope === "stores" && (
                <SkeletonWrapper
                  isLoading={(isEdit || isShow) && couponLoading}
                >
                  <EnhancedSearchStore  isMulti={true} value={formData.selectedStores} setStoreId={setStoreId}/>    
                  {/* <Select
                    isMulti
                    options={stores.map((s) => ({
                      value: s.id,
                      label: s.name,
                    }))}
                    value={formData.selectedStores}
                    onChange={(selected) =>
                      handleSelectChange("selectedStores", selected)
                    }
                    placeholder="اختر المتاجر"
                    isDisabled={isShow}
                  /> */}
                </SkeletonWrapper>
              )}

              <div className="form-check">
                <input
                  className="form-check-input"
                  type="radio"
                  name="couponScope"
                  id="scopeCategories"
                  value="categories"
                  checked={couponScope === "categories"}
                  onChange={(e) => {
                    setCouponScope(e.target.value);
                    // Clear other selections
                    setFormData((prev) => ({
                      ...prev,
                      selectedProducts: [],
                      selectedStores: [],
                    }));
                  }}
                  disabled={isShow}
                />
                <label className="form-check-label" htmlFor="scopeCategories">
                  الفئات
                </label>
              </div>

              {couponScope === "categories" && (
                <SkeletonWrapper
                  isLoading={(isEdit || isShow) && couponLoading}
                >
                  <Select
                    isMulti
                    options={categories.map((s) => ({
                      value: s.id,
                      label: s.name,
                    }))}
                    value={formData.selectedCategories}
                    onChange={(selected) =>
                      handleSelectChange("selectedCategories", selected)
                    }
                    placeholder="اختر الفئات"
                    isDisabled={isShow}
                  />
                </SkeletonWrapper>
              )}
            </div>
          </div>
          <div className="col-4">
            <label className="form-label">نوع الخصم</label>
            <SkeletonWrapper isLoading={(isEdit || isShow) && couponLoading}>
              <select
                className="form-select"
                name="discount_type"
                value={formData.discount_type}
                onChange={handleChange}
                disabled={isShow}
              >
                <option value="">اختر نوع الخصم</option>
                <option value="percentage">نسبة</option>
                <option value="fixed">ثابت</option>
              </select>
            </SkeletonWrapper>
          </div>
          <div className="col-8 d-flex align-items-end">
            <SkeletonWrapper
              isLoading={(isEdit || isShow) && couponLoading}
              className="w-100"
            >
              <input
                type="number"
                name="discount_amount"
                className="form-control"
                placeholder="ادخل الخصم"
                value={formData.discount_amount}
                onChange={handleChange}
                disabled={isShow}
              />
            </SkeletonWrapper>
          </div>

          <div className="col-12">
            <label className="form-label">الحد الأدنى للطلب</label>
            <SkeletonWrapper isLoading={(isEdit || isShow) && couponLoading}>
              <input
                type="number"
                name="minimum_order_amount"
                className="form-control"
                placeholder="ادخل الحد الأدنى للطلب"
                min={0}
                value={formData.minimum_order_amount}
                onChange={handleChange}
                disabled={isShow}
              />
            </SkeletonWrapper>
          </div>

          <div className="col-md-6">
            <label className="form-label">تاريخ البداية</label>
            <SkeletonWrapper isLoading={(isEdit || isShow) && couponLoading}>
              <input
                type="date"
                name="start_date"
                className="form-control"
                value={formData.start_date}
                onChange={handleChange}
                disabled={isShow}
              />
            </SkeletonWrapper>
          </div>
          <div className="col-md-6 ">
            <label className="form-label">تاريخ النهاية</label>
            <SkeletonWrapper isLoading={(isEdit || isShow) && couponLoading}>
              <input
                type="date"
                name="end_date"
                className="form-control"
                value={formData.end_date}
                onChange={handleChange}
                disabled={isShow}
              />
            </SkeletonWrapper>
          </div>
          <div className="col-12">
            <div>
              <label htmlFor="">نشط</label>
              <label class="switch">
                <input
                  type="checkbox"
                  name="is_active"
                  onChange={handleChange}
                  checked={formData.is_active === 1}
                />
                <span className="slider round"></span>
              </label>
            </div>
          </div>
        </div>
      </ModalBody>

      {isShow ? null : (
        <ModalFooter>
          <div className="col-2">
            <ButtonGlobal
              className="btn-primary"
              onClick={handleSubmit}
              label={buttonText}
              isLoading={isEdit ? updateMutation.isLoading : mutation.isLoading}
              disabled={isEdit ? updateMutation.isLoading : mutation.isLoading}
            />
          </div>
          <button className="btn btn-white" type="button" onClick={onClose}>
            إلغاء
          </button>
        </ModalFooter>
      )}
    </Modal>
  );
};

export default AddModalCoupon;
